// const WEBSOCKET_URL = "ws://127.0.0.1:5010"
const WEBSOCKET_URL = "wss://connect.magicform.dev";
// const HTTP_URL = "http://127.0.0.1:5010"
const HTTP_URL = "https://connect.magicform.dev";

export const callIntro = async (stackId, domain) => {
  const url = `${HTTP_URL}/ws/init?stack_id=${stackId}&source_type=web&domain=${domain}`;
  return fetch(url, {
    method: "GET",
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.status === "success") {
        return data.data;
      }
      return null;
    });
};

export const connectToWebsocketIntro = ({
  onOpen,
  onMessage,
  onClose,
  sessionId,
  stackId,
  domain,
}) => {
  const socket = new WebSocket(
    `${WEBSOCKET_URL}/ws/connect?stack_id=${stackId}&source_type=widget&domain=${domain}&session_id=${sessionId}`,
  );
  socket.onopen = () => {
    console.log("Widget connected to websocket");
    onOpen();
  };
  socket.onmessage = (event) => {
    if (event.isTrusted) {
      onMessage(event.data);
    }
  };
  socket.onclose = () => {
    console.log("Widget disconnected");
    onClose();
  };
  return socket;
};
